import type { ProgramInterface } from "../types/program.interface";
import type { UserProgram } from "../types/userProgram.interface";
import { API_BASE_URL } from './constants';
import { trackEvent } from './analytics.service';
import type { Comment } from "../components/programs-profile/CommentsList";
import { authenticatedFetch } from "@beholos/holoscommon";

export const fetchPrograms = async (): Promise<ProgramInterface[]> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/programs`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: { programs: ProgramInterface[] } = await response.json();
    console.log('Programs API response:', data);

    return data.programs;
  } catch (error) {
    console.error('Error fetching programs:', error);
    return [];
  }
};

export interface FetchProgramBySlugResponse {
  program: ProgramInterface;
  otherPrograms: ProgramInterface[];
  userProgram?: UserProgram;
  reviews: Comment[];  
  programComplete?: boolean;
  programCompleteShown?: boolean;
  programReview?: {
    rating: number;
    review: string;
  };
}

export const fetchProgramBySlug = async (slug: string): Promise<FetchProgramBySlugResponse | null> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/programs/show/${slug}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: FetchProgramBySlugResponse = await response.json();
    console.log('Programs API response:', data);

    return data;
  } catch (error) {
    console.error('Error fetching programs:', error);
    return null;
  }
};

export const fetchUserPrograms = async (): Promise<UserProgram[] | null> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/programs/user-programs`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: UserProgram[] = await response.json();
    console.log('User Programs API response:', data);

    return data;
  } catch (error) {
    console.error('Error fetching user programs:', error);
    return null;
  }
};

export const enrollInProgram = async (programId: string): Promise<string> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/programs/enroll`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ program: programId }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    trackEvent('program_enrollment', { program_id: programId });

    return data.message;
  } catch (error) {
    console.error('Error enrolling user in program:', error);
    return 'Algo salió mal al inscribir al usuario en el programa';
  }
};

export const createReview = async (programId: string, rating: number, review: string): Promise<string> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/programs/review`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ programId, rating, review }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return 'Reseña creada correctamente';
  } catch (error) {
    console.error('Error creating review:', error);
    return 'Algo salió mal al crear la reseña';
  }
};